import { ethers } from 'ethers'

export const isValidAddress = (address: string | undefined | null) => {
  if (address === null || address === undefined || address.length === 0) return false
  if (address === ethers.constants.AddressZero) return false
  try {
    ethers.utils.getAddress(address)
    return true
  } catch (err) {
    return false
  }
}
